import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../../../../commons/services/common.service';

@Component({
  selector: 'app-location-facturation-devis',
  templateUrl: './location-facturation-devis.component.html',
  styleUrls: ['./location-facturation-devis.component.css']
})
export class LocationFacturationDevisComponent implements OnInit {
  @Input() contenant;
  @Input() client;
  loadingIndicator: Boolean = false;
  qteSupp: Boolean = false;
  facturation: any = {};

  periodeLocation = [
    { id: 1, libelleObjetEntite: 'Mensuelle' },
    { id: 2, libelleObjetEntite: 'Trimestrielle' },
    { id: 3, libelleObjetEntite: 'Semestrielle' },
    { id: 4, libelleObjetEntite: 'Annuelle' },
  ];

  typeFacturation = [
    { id: 0, libelleObjetEntite: 'Au mois' },
    { id: 1, libelleObjetEntite: 'A la journée' },
  ];

  @Output() hidefunction = new EventEmitter<any>();
  @Output() validefunction = new EventEmitter<any>();
  societe: any;
  constructor(public common: CommonService) { }

  ngOnInit() {
    this.contenant = this.contenant || {};
    console.log(this.contenant);
    this.societe = this.common.local.getObject('paramSociete') || {};
    const societe = this.common.local.getObject('paramSociete') || {};
    this.client = this.client || {};
    this.chargeValue()
  }

  chargeValue() {
    this.facturation = Object.assign({}, this.contenant);
    this.facturation['typeLocation'] = this.facturation['typeLocation'] || 1;
    this.periodeLocation.forEach(elt => {
      if (elt.id === parseInt(this.facturation['typeLocation'], 10)) {
        this.facturation['periodeLoc'] = elt;
      }
    })
    if (!this.facturation['id']) {
      const isLocImmediat = this.client.isLocImmediat || this.societe.isLocImmediat ? true : false;
      this.facturation['isLocImmediat'] =  isLocImmediat;
      const isLocJournalier = this.client.isLocJournalier ? true : false;
      if (isLocJournalier) {
        this.facturation['isLocJour'] = true;
      }
    } else {
       this.facturation['isLocImmediat'] = this.facturation['isLocImmediat'] || false;
    }

    this.facturation['typeFact'] = this.facturation['isLocJour'] ? this.typeFacturation[1] : this.typeFacturation[0];
    this.facturation['isTarifLoc'] = this.facturation['isTarifLoc'] || false;
    this.facturation['tarifLoc'] = this.facturation['tarifLoc'] || 0;
    this.facturation['nbrRotTarifLoc'] = this.facturation['nbrRotTarifLoc'] || 0;
    this.facturation['isTarifRot'] = this.facturation['isTarifRot'] || false;
    this.facturation['tarifRot'] = this.facturation['tarifRot'] || 0;
    this.facturation['nbrRotGratuite'] = this.facturation['nbrRotGratuite'] || 0;
    this.facturation['commentairesFact'] = this.facturation['commentairesFact'] || '';
  }

  valideValue() {
    this.contenant['typeLocation'] = this.facturation['periodeLoc'].id || 1;
    this.contenant['isLocJour'] = this.facturation['typeFact'] && this.facturation['typeFact'].id === 1 ? true : false;

    this.contenant['isLocImmediat'] = this.facturation['isLocImmediat'] || false;
    this.contenant['isTarifLoc'] = this.facturation['isTarifLoc'] || false;
    this.contenant['tarifLoc'] = this.facturation['tarifLoc'] || 0;
    this.contenant['nbrRotTarifLoc'] = this.facturation['nbrRotTarifLoc'] || 0;
    this.contenant['isTarifRot'] = this.facturation['isTarifRot'] || false;
    this.contenant['tarifRot'] = this.facturation['tarifRot'] || 0;
    this.contenant['nbrRotGratuite'] = this.facturation['nbrRotGratuite'] || 0;
    this.contenant['commentairesFact'] = this.facturation['commentairesFact'] || '';
  }

  showFiche() {
    this.hidefunction.emit();
  }

  save() {
    this.valideValue();
    this.validefunction.emit(this.contenant);
    this.hidefunction.emit();
  }
}
